import { APIHandler } from "../../base";
import type {
    CreateOrchestratorRequest,
    UpdateAgentRequest
} from "../../../common/interfaces/admin/agent.interface";

export const fetchAgents = (companyId: number) => APIHandler.get(`/admin/${companyId}/agents`);

export const fetchAgentModels = (companyId: number) =>
    APIHandler.get(`/admin/${companyId}/agents/models`);

export const fetchAgenticFlag = (companyId: number) =>
    APIHandler.get(`/admin/${companyId}/agents/flag`);

export const setAgenticFlag = (companyId: number, enabled: boolean) =>
    APIHandler.put(`/admin/${companyId}/agents/flag`, { enabled });

export const updateAgent = (companyId: number, agentUid: string, data: UpdateAgentRequest) =>
    APIHandler.patch(`/admin/${companyId}/agents/${agentUid}`, data);

export const deleteAgent = (companyId: number, agentUid: string) =>
    APIHandler.delete(`/admin/${companyId}/agents/${agentUid}`);

export const setAgentSpecialists = (
    companyId: number,
    agentUid: string,
    specialistUids: string[]
) => APIHandler.put(`/admin/${companyId}/agents/${agentUid}/specialists`, { specialistUids });

export const createSpecialist = (companyId: number, knowledgeBaseUid: string) =>
    APIHandler.post(`/admin/${companyId}/agents/specialist`, { knowledgeBaseUid });

export const createOrchestrator = (companyId: number, data: CreateOrchestratorRequest) =>
    APIHandler.post(`/admin/${companyId}/agents/orchestrator`, data);

export const setKnowledgeBaseAgent = (
    companyId: number,
    knowledgeBaseUid: string,
    agentUid: string | null
) =>
    APIHandler.patch(`/admin/${companyId}/agents/knowledge-bases/${knowledgeBaseUid}`, {
        agentUid
    });

export const fetchFlaggedAnswers = (companyId: number, page = 1) =>
    APIHandler.get(`/admin/${companyId}/agents/flagged-answers?page=${page}`);
